import { Injectable, Injector } from "@angular/core";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ConfigurationService } from "app/shared/services/configuration.service";

@Injectable()
export class AppInsightService {
  private appInsights: ApplicationInsights | undefined;

  constructor(private injector: Injector) {
    const configurationService = this.injector.get(ConfigurationService);
    const instrumentationKey =
      configurationService.serverSettings.applicationInsights
        .instrumentationKey;
    if (instrumentationKey) {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: instrumentationKey,
        },
      });
      this.appInsights.loadAppInsights();
    }
  }
  logPageView(
    name?: string,
    url?: string,
    properties?: any,
    measurements?: any,
    duration?: number
  ) {}
  logEvent(name: string, properties?: any, measurements?: any) {}
  logException(
    exception: Error,
    handledAt?: string,
    properties?: any,
    measurements?: any
  ) {
    if (this.appInsights) {
      this.appInsights.trackException({ error: exception });
      this.appInsights.flush();
    }
  }
  logTrace(message: string, properties?: any, severityLevel?: any) {}
}
